import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import Group from '../Group/Group';
import News from '../News/News';
import References from '../References/References';
import MediaLibrary from '../MediaLibrary/MediaLibrary';
import Standard from '../Standard/Standard';
import appData from '../../data/app.json';

import './Section.css';

const Section = (props) => {
	const data = appData.sections[props.currentSection];
	if(!data) {
		console.error('Could not find section', props.currentSection, data);
	}
	return (
		(data && 
		<section
			className={'section ' + (props.unityDisplay ? 'hidden': '')}
			style={(data.image ? { backgroundImage: `url('${data.image}')` } : null)}
		>
			{
				data.type === 'standard' &&
				<Standard data={data} />
			}
			{
				data.type === 'references' &&
				<References data={data} />
			}
			{
				data.type === 'media-library' &&
				<MediaLibrary data={data} />
			}
			{
				data.type === 'news' &&
				<News data={data} />
			}
			{
				data.groups && data.groups.map((item, i) => {
					return (props.currentGroup === i) &&
						<Group key={`group-${i}`} 
							data={item} 
							sectionCount={appData.sections.length} 
							groupCount={data.groups.length} 
							currentSection={props.currentSection} 
							currentGroup={props.currentGroup} 
							currentStage={props.currentStage} 
						/>;
				})
			}
		</section>)
		|| ''
	);
};

function mapStateToProps(state) {
	// console.log('state.navigation.unityDisplay', state.navigation.unityDisplay)
	return {
		unityDisplay: state.navigation.unityDisplay,
	};
}

Section.propTypes = {
	currentSection: propTypes.number.isRequired,
	currentGroup: propTypes.number,
	unityDisplay: propTypes.bool.isRequired,
};

export default connect(mapStateToProps)(Section);


// WEBPACK FOOTER //
// ./src/components/Section/Section.js